import React from 'react';
import { Price } from 'src/components/Helpers/Price';
import { AlternativeSku } from 'src/types/global-types';
import classnames from 'classnames';
import { sortOptions } from 'src/util/sortOptions';
import { useVatCausesRender } from 'src/components/AppShell/VatProvider';

import classes from './AlternativeProduct.scss';

type Props = {
    alternativeSku: AlternativeSku;
};

export const AlternativeProduct: React.FC<Props> = ({ alternativeSku }) => {
    const { product, percentSaved, alternativeSizes } = alternativeSku;
    const { vat } = useVatCausesRender();

    const sortedSizes = sortOptions(alternativeSizes);

    return (
        <div className={classes.alternativeProduct}>
            <div className={classes.image}>
                <img src={product.selectionImage} alt="" />
            </div>
            <div className={classes.information}>
                <p className={classes.title}>{product.name}</p>
                <div className={classes.details}>
                    <div className={classes.prices}>
                        From
                        <Price
                            price={product.priceRange.minimumPrice.finalPriceExclFormatted}
                            priceIncl={product.priceRange.minimumPrice.finalPriceFormatted}
                            vat={vat}
                        />
                    </div>
                    {percentSaved !== 0 && (
                        <div className={classes.discount}>
                            Save {percentSaved < 0 ? percentSaved * -1 : percentSaved}%
                        </div>
                    )}
                </div>
            </div>
            <div className={classes.viewButton}>
                <a href={`/${product.urlKey}`}>View</a>
            </div>
            <div className={classes.sizesWrapper}>
                <p>Sizes: </p>
                <div className={classes.sizes}>
                    {sortedSizes.map((size, key) => (
                        <span
                            key={key}
                            className={classnames(classes.chatIcon, {
                                [classes.active]: size.stockQty > 10,
                                [classes.pending]: size.stockQty < 10 && size.stockStatus === 'IN_STOCK',
                                [classes.outOfStock]: size.stockStatus === 'OUT_OF_STOCK',
                            })}
                        >
                            {size.sizeLabel}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};
